export function extractLeafContextFileKey(fileKey: string): string {
  return fileKey.split("/").pop() || fileKey;
}

export function buildFullContextFileKey(params: {
  fileKey: string;
  userId: string;
  sessionId: string;
}): string {
  const { fileKey, userId, sessionId } = params;

  if (fileKey.includes("/")) {
    return fileKey;
  }

  return `${userId}/${sessionId}/${fileKey}`;
}
